import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const KeyIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 30 30" fill="none" {...props}>
    <path
      d="M21.25 11.2499C21.25 10.6101 21.0059 9.97037 20.5178 9.48223C20.0296 8.99408 19.3898 8.75 18.75 8.75M18.75 18.75C22.8921 18.75 26.25 15.3921 26.25 11.25C26.25 7.10786 22.8921 3.75 18.75 3.75C14.6079 3.75 11.25 7.10786 11.25 11.25C11.25 11.5921 11.2729 11.9288 11.3173 12.2588C11.3902 12.8015 11.4267 13.0728 11.4021 13.2445C11.3766 13.4233 11.344 13.5197 11.2559 13.6774C11.1712 13.8288 11.0221 13.9779 10.7239 14.2761L4.33579 20.6642C4.1196 20.8804 4.0115 20.9885 3.9342 21.1146C3.86566 21.2265 3.81516 21.3484 3.78454 21.476C3.75 21.6198 3.75 21.7727 3.75 22.0784V24.25C3.75 24.9501 3.75 25.3001 3.88624 25.5675C4.00608 25.8027 4.19731 25.9939 4.43251 26.1138C4.6999 26.25 5.04993 26.25 5.75 26.25H8.75V23.75H11.25V21.25H13.75L15.7239 19.2761C16.0221 18.9779 16.1712 18.8288 16.3226 18.7441C16.4803 18.656 16.5767 18.6234 16.7555 18.5979C16.9272 18.5733 17.1985 18.6098 17.7412 18.6827C18.0712 18.7271 18.4079 18.75 18.75 18.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
